<template>
  <div class="contact__container white-back-container">
    <div class="white-back-container__content">
      <div class="contact__header white-back-container__header">
        <h3 class="subhead-bold">
          ご連絡先
        </h3>
        <p class="caption require-caption">
          必須*
        </p>
      </div>
      <div class="contact__input-container white-back-container__inner-content">
        <div class="contact__attention box-list--attention align-left-box-list">
          <p>
            万が一、長期不在などの理由でお届けができない場合、配送業者もしくは店舗よりご連絡させていただくことがございます。
          </p>
          <p>
            事前に「@giftee.com」ドメインのメール受信許可設定をご確認ください。
          </p>
        </div>
        <div class="phone-number__container form-container">
          <div class="form-label body-bold">
            <span class="require">電話番号</span>
          </div>
          <div class="minimal form-minimal-info">
            ハイフンなしでご入力ください
          </div>
          <div class="form-input-group">
            <div v-if="showablePhoneNumberErrorMessage" class="error-message">
              {{ phoneNumberErrorMessage }}
            </div>
            <div class="phone-number-input__container form-input-container">
              <input
                id="delivery_address_form_phone_number"
                v-model="inputPhoneNumber"
                placeholder="1234567890"
                maxlength="11"
                size="11"
                type="tel"
                name="delivery_address_form[phone_number]"
                autocomplete="tel"
                class="input-form"
                :class="{
                  field_with_errors: showablePhoneNumberErrorMessage,
                  'input-form--inputted': isPhoneNumberInputted,
                  'input-form--inputting': isPhoneNumberFocused
                }"
                @focus="onFocusPhoneNumber"
                @blur="onBlurPhoneNumber"
              />
            </div>
          </div>
        </div>
        <div class="email__container form-container">
          <div class="form-label body-bold">
            <span class="require">メールアドレス</span>
          </div>
          <div class="form-input-group">
            <div v-if="showableEmailErrorMessage" class="error-message">
              {{ emailErrorMessage }}
            </div>
            <div class="email-input__container form-input-container">
              <input
                id="delivery_address_form_email"
                v-model="inputEmail"
                placeholder="giftee@sample.com"
                type="email"
                name="delivery_address_form[email]"
                autocomplete="email"
                class="input-form"
                :class="{
                  field_with_errors: showableEmailErrorMessage,
                  'input-form--inputted': isEmailInputted,
                  'input-form--inputting': isEmailFocused
                }"
                @focus="onFocusEmail"
                @blur="onBlurEmail"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    phoneNumber: {
      type: String,
      required: true
    },
    email: {
      type: String,
      required: true
    },
    phoneNumberErrorMessage: {
      type: String,
      required: true
    },
    emailErrorMessage: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isPhoneNumberFocused: false,
      isEmailFocused: false
    }
  },
  computed: {
    inputPhoneNumber: {
      get() {
        return this.$props.phoneNumber
      },
      set(value) {
        this.$emit('change-phone-number', value)
      }
    },
    inputEmail: {
      get() {
        return this.$props.email
      },
      set(value) {
        this.$emit('change-email', value)
      }
    },
    showablePhoneNumberErrorMessage() {
      return this.phoneNumberErrorMessage.length !== 0
    },
    showableEmailErrorMessage() {
      return this.emailErrorMessage.length !== 0
    },
    isPhoneNumberInputted() {
      return this.phoneNumber.length !== 0
    },
    isEmailInputted() {
      return this.email.length !== 0
    }
  },
  methods: {
    onFocusPhoneNumber() {
      this.isPhoneNumberFocused = true
    },
    onFocusEmail() {
      this.isEmailFocused = true
    },
    onBlurPhoneNumber() {
      this.isPhoneNumberFocused = false
    },
    onBlurEmail() {
      this.isEmailFocused = false
    }
  }
}
</script>
<style lang="scss" scoped>
.contact {
  &__attention {
    margin-bottom: 0;
  }
}
</style>
